import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlPresignedUrlState {
    presignedUrl: string | null;
    status: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DlPresignedUrlState = { presignedUrl: null, status: 'pending' };

export const dlPresignedUrlReducer = createReducer(
    initialState,
    on(driverLicenseActions.getPresignedUrl, (state) => ({ ...state, presignedUrl: null, status: 'loading' as const })),
    on(driverLicenseActions.getPresignedUrlSuccess, (state, { payload }) => ({ ...state, presignedUrl: payload, status: 'loaded' as const })),
    on(driverLicenseActions.getPresignedUrlFail, (state) => ({ ...state, presignedUrl: null, status: 'error' as const })),
    on(driverLicenseActions.clearPresignedUrl, () => initialState)
);
